export default "__VITE_ASSET__qWxOOSfQ__"